import gql from 'graphql-tag';

export default gql`
  mutation deleteMetatag($id: UUID!) {
    deleteMetatag(_id: $id)
  }
`;
